module.exports = __webpack_public_path__ + "img/rating-year-5-star.6ad9ea79.svg";